<template>
  <div ref='drillDownTarget' :id="id" class="item" :class='klass' :key="key">
    <div v-if="isAnyMeasure" @click='visit()'>
      <span>{{ item.dname }}</span>
      <span style="float:right;clear=right">{{ item.value }} {{ item.units?'('+item.units+')':'' }}</span>
      <!-- <watch-button-measure v-if="isWatchable" class="watch-button-in-cda" :measKind="kind" :procCcd="item.procCcd" :measCcd="item.ccd"/> -->
    </div>
    <div v-else-if="isAnyProcedure" class='accordion procedure w-100' :class='klass' v-on="visitable0 ? { click:visit }:{}">
      <!-- <watch-button-procedure class='watch-button-in-cda' v-if='isProcedure' :procCcd='item.ccd' :procId='item.id'/> -->
      <div class='card'>
        <togglable-caret-header class='card-header' data-bs-toggle='collapse' :data-bs-target='dataTarget' :showCaret='isPopulatedAnyProcedure' :class='togglableClass'>
          <a role='button'>{{ item.desc.toLowerCase() }}</a>
          <watch-button-procedure class='watch-button-in-cda' v-if='isProcedure' :procCcd='item.ccd' :procId='item.id'/>
        </togglable-caret-header>
        <div class='collapse' :id='dataTargetId'>
          <div class='card-body'>
            <cda-visitable-item v-for="measure in item.measures" :key="'submeasurekey'+measure.id" :item='measure'>
            </cda-visitable-item>
          </div>
        </div>
        <!-- <watch-button-procedure class='watch-button-in-cda 2' v-if='isProcedure' :procCcd='item.ccd' :procId='item.id'/> -->
      </div>
    </div>
    <div v-else @click='visit()'>
      <span v-if='mayHaveSubstance'>{{ item.substance || item.desc }}</span>
      <span v-else>{{ item.desc }}</span>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import WatchButtonMeasure from '@/components/private-layouts/_partials/watch/WatchButtonMeasure';
import WatchButtonProcedure from '@/components/private-layouts/_partials/watch/WatchButtonProcedure';
import kinds from '@/constants/kinds';
import types from '@/data/types';
import { hasMeasures,isOfficeVisit } from '@/data/getters';
import { mapGetters } from 'vuex';
import TogglableCaretHeader from '@/components/includes/TogglableCaretHeader';

export default {
  name: 'cda-visitable-item',
  props: {
    item: null
  },
  watch: {
    ready(newReady) {
      if(newReady && this.matches) {
        this.drillDownTarget.scrollIntoView({block:'center'});
        this.visit();
      }
    }
  },
  data() {
    return {
      kinds,
      types
    }
  },
  components: {
    'watch-button-measure': WatchButtonMeasure,
    'watch-button-procedure': WatchButtonProcedure,
    'togglable-caret-header': TogglableCaretHeader
  },
  computed: {
    ...mapGetters('login', {
      allData: 'getAllData'
    }),
    dataTargetId() {
      return 'measures-target-' + this.item.id;
    },
    dataTarget() {
      return '#'+ this.dataTargetId;
    },
    togglableClass() {
      return {
        'office-visit' : isOfficeVisit(this.item,this.allData)
      };
    },
    kind() {
      return this.item.kind;
    },
    isPopulatedProcedure() {
      return this.kind === 'procedure' && hasMeasures(this.item.id,this.allData);
    },
    isPopulatedEditableProcedure() {
      return this.kind === 'eprocedure' && hasMeasures(this.item.id,this.allData,this.item.cdaIndex);
    },
    isPopulatedAnyProcedure() {
      return this.isPopulatedProcedure || this.isPopulatedEditableProcedure;
    },
    isProcedure() {
      return this.kind === this.kinds.PROCEDURE;
    },
    isEditableProcedure() {
      return this.kind === this.kinds.E_PROCEDURE;
    },
    isAnyProcedure() {
      return this.isProcedure || this.isEditableProcedure;
    },
    isAnyDiagnosis() {
      return this.kind === this.kinds.E_DIAGNOSIS || this.kind === this.kinds.DIAGNOSIS;
    },
    isAnyAllergy() {
      return this.kind === this.kinds.E_ALLERGY || this.kind === this.kinds.ALLERGY;
    },
    mayHaveSubstance() {
      return (this.isAnyAllergy || this.isAnyDiagnosis) && !this.item.hasallergencode;
    },
    isWatchable() {
      return this.isMeasure || this.isPopulatedProcedure;
    },
    isMeasure() {
      return this.kind === 'measures';
    },
    isEditableMeasure() {
      return this.kind === 'emeasure';
    },
    isAnyMeasure() {
      return this.isMeasure || this.isEditableMeasure;
    },
    id() {
      return this.item.htmlname;
    },
    klass() {
      return '' +
        (this.visitable ? " clickable":"") +
        (this.selected ? " selected":"");
    },
    key() {
      let prefix = this.isParentVisitableItem ? 'cda-visitable-subitem' : 'cda-visitable-item';
      return prefix+this.kind+this.item.id;
    },
    isParentVisitableItem() {
       return this.$parent.$options.name === 'cda-visitable-item';
    },
    drillDownTarget() {
      return this.$refs.drillDownTarget;
    },
    visitable0() {
      let result =  this.visitable;
      let result0 = Boolean(this.item.htmlname && !this.isPopulatedAnyProcedure);
      return result;
    },
    visitable() {
      return Boolean(this.item && this.item.htmlname && !this.isPopulatedAnyProcedure);
    },
    selected() {
      return this.selectedItem === this;
    },
    matches() {
      if(!this.itemInfo)
        return false;
      let itemInfo = this.itemInfo;
      let type = itemInfo.type;
      let kind = this.kind;
      return itemInfo.id === this.item.id && (
          (kind === kinds.VACCINE && type === types.vaccination) ||
          (kind === kinds.DIAGNOSIS && type === types.diagnosis) ||
          (kind === kinds.ALLERGY && type === types.allergy) ||
          (kind === kinds.MEDICATION && type === types.medication));
    },
    itemInfo() {
      return this.$parent.itemInfo;
    },
    ready() {
      return this.$parent.ready;
    },
    selectedItem() {
      return this.$parent.selectedItem;
    }
  },
  methods: {
    visit() {
      let iframe = $('iframe');
      let find = (htmlname) => iframe.contents().find(htmlname);
      let iframeHeight = iframe.height();
      let iframeWindow = iframe[0].contentWindow;
      let eventTarget = this.isParentVisitableItem ? this.$parent : this;

      eventTarget.$emit('selection-changed-event',null);
      eventTarget.$emit('selection-changed-event',this);
      if(!this.visitable)
        return;
      // get element to visit
      let elementToVisit = find(this.item.htmlname);
      let elementToVisitTop = elementToVisit.offset().top;
      let elementToVisitHeight = elementToVisit.height();

      // find positions where to scroll
      let horizontalScroll = 0;
      let verticalScroll = elementToVisitTop 
        - iframeHeight / 2 + elementToVisitHeight / 2;

      iframeWindow.scrollTo(horizontalScroll, verticalScroll);     

      const className = 'selected-D18AC1FAF08C41F9A02F173FCFFB59A1';
      find('*').removeClass(className);
      elementToVisit.addClass(className);
    }
  }
}

</script>

<style scoped lang="scss">

$tint: rgba(0,0,0,.2);
$tint2: rgba(0,0,0,.08);

$selected: rgba(255,255,0,1);
$selectedTint: rgba(0,0,255,.15);

.procedure {
    display: inline-flex;

  }
  .card {
    width: 100%;
    padding: 0;
    border: none;
    background-color: transparent;

    .card-header {
      /*padding: 0;*/
      width: 100%;
      border: none;
      background-color: transparent;
      text-transform: capitalize;
      padding: 0.5rem 1.0rem 0.5rem 0;
    }

    .card-body {
      padding: 0;
      background-color: transparent;
    }
    .office-visit {
      opacity: .6;
      font-size: .7rem;
    }
  }

  .item {
    padding: 0 0.5rem;
    width: 100%;
  }
  .clickable.selected:hover {
    background-color: $selected;
  }
  .selected:not(:hover) {
    background-color: $selectedTint;
    animation-name : fade;
    animation-duration: .3s;
  }
  @keyframes fade {
    from { background-color: $selected; }
    60% { background-color: $selected; }
    to { background-color: $selectedTint; }
  }
  .clickable.selected:not(:hover) {
    background-color:$selectedTint;
  }
  .clickable:not(:hover) {
    background-color : $tint2;
  }
  .clickable:hover {
    background-color : $tint;
  }
  .watch-button-in-cda {
    display: inline-block;
    padding: 0;
  }

</style>
